/* Studio VormVezel – collectiepagina (sections/vv-collection.liquid). Geen afhankelijkheden.
   - select[data-vv-sort]: sorteren verstuurt het formulier [data-vv-sort-form] (zonder JavaScript: knop in <noscript>).
     Met de muis of op een telefoon meteen; met het toetsenbord pas na een korte pauze, bij Enter of als je de lijst verlaat,
     zodat je met de pijltjes door de opties kunt zonder dat de pagina bij elke stap opnieuw laadt.
   - [data-vv-chips]: op smalle schermen de actieve chip (aria-current) in beeld schuiven, zoals chipIntoView() in de demo
     (ook na shopify:section:load en bij shopify:block:select in de thema-editor).
   - Na sorteren, een andere productlijn, een andere pagina of een filter: terug naar de filterbalk in plaats van naar de
     bovenkant. Wie het met het toetsenbord deed, krijgt de focus terug op de keuzelijst, de chip of de eerste kaart. */
(function () {
  'use strict';
  var D = document, KEY = 'vv-coll-nav', viaKey = false, sortTimer = null;
  function $(s, r) { return (r || D).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function stickTop(bar) { var t = 0; try { t = parseFloat(getComputedStyle(bar).top); } catch (e) {} return isNaN(t) ? 0 : t; }

  /* Laatste invoer: toetsenbord of muis/aanraken (alleen voor de focus na het laden) */
  D.addEventListener('keydown', function (e) { if (!e.metaKey && !e.ctrlKey && !e.altKey) viaKey = true; }, true);
  D.addEventListener('mousedown', function () { viaKey = false; }, true);
  D.addEventListener('touchstart', function () { viaKey = false; }, { capture: true, passive: true });

  /* Onthouden waar de bezoeker was (alleen als de filterbalk al bovenaan vastzit of voorbij is) */
  function remember(focus) {
    var bar = $('.coll-bar'); if (!bar) return;
    var stuck = (window.pageYOffset || 0) > 0 && bar.getBoundingClientRect().top <= stickTop(bar) + 2;
    try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), stuck: stuck, focus: focus || '' })); } catch (e) {}
  }
  function restore() {
    var v = null;
    try { v = JSON.parse(sessionStorage.getItem(KEY) || 'null'); sessionStorage.removeItem(KEY); } catch (e) { v = null; }
    if (!v || Date.now() - v.t > 20000) return;
    var bar = $('.coll-bar');
    if (bar && v.stuck) {
      var y = bar.getBoundingClientRect().top + (window.pageYOffset || 0) - stickTop(bar);
      window.scrollTo(0, Math.max(0, y));
    }
    var el = null;
    if (v.focus === 'sort') el = $('select[data-vv-sort]');
    else if (v.focus === 'chip') el = $('[data-vv-chips] [aria-current]');
    else if (v.focus === 'page') el = $('.grid-cards .card-title a') || $('.coll-empty a');
    if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  }

  /* Gekozen chip in beeld (horizontaal scrollende rij op mobiel) */
  function chipIntoView(root) {
    $$('[data-vv-chips]', root).forEach(function (c) {
      var on = c.querySelector('[aria-current]');
      if (on && c.scrollWidth > c.clientWidth) c.scrollLeft = Math.max(0, on.offsetLeft - (c.clientWidth - on.offsetWidth) / 2);
    });
  }

  /* Sorteren */
  function sendSort(sel) {
    clearTimeout(sortTimer); sortTimer = null;
    var f = sel.form || sel.closest('form'); if (!f) return;
    var was = sel.getAttribute('data-vv-sent');
    if (was === null) { var o = sel.querySelector('option[selected]'); was = o ? o.value : ''; }
    if (was === sel.value) return; /* terug op de huidige sortering: niets te doen */
    sel.setAttribute('data-vv-sent', sel.value);
    remember(viaKey ? 'sort' : '');
    if (typeof f.requestSubmit === 'function') f.requestSubmit(); else f.submit();
  }
  D.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('select[data-vv-sort]'); if (!sel) return;
    if (viaKey) { clearTimeout(sortTimer); sortTimer = setTimeout(function () { sendSort(sel); }, 1200); }
    else sendSort(sel);
  });
  D.addEventListener('keydown', function (e) {
    var sel = e.target.closest && e.target.closest('select[data-vv-sort]'); if (!sel) return;
    if (e.key === 'Enter' && sortTimer) { e.preventDefault(); sendSort(sel); }
  });
  D.addEventListener('focusout', function (e) {
    var sel = e.target.closest && e.target.closest('select[data-vv-sort]'); if (sel && sortTimer) sendSort(sel);
  });

  /* Chips, paginering en filters: positie onthouden (e.detail === 0: geactiveerd met het toetsenbord) */
  D.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a'); if (!a) return;
    var kb = e.detail === 0;
    if (a.closest('[data-vv-chips]')) remember(kb ? 'chip' : '');
    else if (a.closest('.vv-pag')) remember(kb ? 'page' : '');
    else if (a.closest('.vv-filters')) remember('');
  });

  chipIntoView(D);
  restore();
  /* Thema-editor: na het opnieuw laden van de sectie de actieve chip weer in beeld; een gekozen chip-blok in beeld schuiven */
  D.addEventListener('shopify:section:load', function (e) { chipIntoView(e.target); });
  D.addEventListener('shopify:block:select', function (e) {
    var el = e.target, c = el && el.closest && el.closest('[data-vv-chips]');
    if (c && c.scrollWidth > c.clientWidth) c.scrollLeft = Math.max(0, el.offsetLeft - (c.clientWidth - el.offsetWidth) / 2);
  });
})();
